import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const DeleteMovimiento = () => {
  const api = useApi();

  const mutate = async (params) => {
    const { data } = await api.del(`/administracion-inventario/eliminar-movimiento/${params}`, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data;
  };

  const mutation = useMutation(mutate);

  return {
    deleteMovimientoMutation: mutation.mutate,
  };
};
